<mat-card appearance="outlined">
  <!-- Cabecera -->
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Casos</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {} })"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Caratula</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Caratula" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="t w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaTipoCaso" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Caso </mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdTipoCasoCaso">
              <mat-option [value]="tipoCasos.id" *ngFor="
                  let tipoCasos of tiposCasos;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ tipoCasos.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>

        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Barra de acciones -->
    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <!-- Tabla De datos -->
    <div>

      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
        <ng-container matColumnDef="select">

          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="caratula">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Caratula</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            {{ caso.caratula | uppercase }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaComienzo">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha
              Comienzo</strong></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            {{ caso.fechaComienzo | date : "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaFinalizacion">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha Finalización</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            {{ caso.fechaFinalizacion | date : "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoCaso">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Tipo
              Caso</strong></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            {{
            caso.tipoCaso == undefined
            ? ""
            : (caso.tipoCaso.descripcion | uppercase)
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoCaso">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado Caso</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            {{
            caso.estadoCaso == undefined
            ? ""
            : (caso.estadoCaso.descripcion | uppercase)
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="activo">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let caso">
            <app-status-badge [estado]="caso.activo"></app-status-badge>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
